import React from 'react';

import { useMutation } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';

import FormContainer from '../../../../FormContainer';
import Alert from '../../../../../Alert';

import usePayoffInvoiceForm from '../../../../../../forms/loan/payoffInvoice';
import LoanService from '../../../../../../services/LoanService';
import { useUiContext } from '../../../../../../context/UiContext';

export default function CreatePayoffInvoice({ lienHolder, loanId, refetch }) {
  const { showToast } = useUiContext();

  const navigate = useNavigate();

  const { mutate: createPayoffInvoice, isPending } = useMutation({
    mutationFn: (formValues) =>
      LoanService.createPayoffInvoice({ loanId, formValues }),
    onSuccess: () => {
      showToast({
        text: 'Payoff invoice(s) prepared successfully',
        type: 'success',
      });
      refetch();
      navigate(`/loans/${loanId}?tab=Schedule`);
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const form = usePayoffInvoiceForm(createPayoffInvoice, null, !!lienHolder);

  return (
    <div>
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
          Create Payoff Invoice(s)
        </h2>
        {!lienHolder && (
          <Alert
            message={
              <>
                This loan has no lien holders. If this is not correct, set the
                lien holder in the{' '}
                <Link
                  className="text-indigo-500 underline"
                  to={`/loans/${loanId}?tab=Settings`}
                >
                  loan settings
                </Link>
                .
              </>
            }
          />
        )}
        <FormContainer
          form={form}
          noBillComId
          groupSizeOffset={1}
          isSubmitting={isPending}
        />
      </div>
    </div>
  );
}
